export default __webpack_public_path__ + "static/03-8fdf7dd46179056eee8331c787de7c76.jpg";